/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "./generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type BasicOrgFragment = {
  readonly __typename: "Org";
  readonly id: c.OrgId;
  readonly displayName: string;
};

export type OrgsClientQueryVariables = Types.Exact<{ [key: string]: never }>;

export type OrgsClientQuery = {
  readonly __typename: "Query";
  readonly orgsClient: {
    readonly __typename: "ClientOrgResponse";
    readonly loaded: boolean;
    readonly orgs: ReadonlyArray<{
      readonly __typename: "Org";
      readonly id: c.OrgId;
      readonly displayName: string;
    }>;
  };
};

export type BasicOrgFragmentForPickerFragment = {
  readonly __typename: "User";
  readonly id: c.UserId;
  readonly email: string;
  readonly org: {
    readonly __typename: "Org";
    readonly id: c.OrgId;
    readonly ssoEnforced: boolean;
    readonly displayName: string;
  };
};

export type WorkspacePickerFragment = {
  readonly __typename: "User";
  readonly id: c.UserId;
  readonly orgRole: Types.OrgRole;
  readonly email: string;
  readonly org: {
    readonly __typename: "Org";
    readonly id: c.OrgId;
    readonly userCount: number;
    readonly displayName: string;
  };
};

export type OrgsPickerClientQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type OrgsPickerClientQuery = {
  readonly __typename: "Query";
  readonly orgPickerClient: {
    readonly __typename: "ClientOrgPickerResponse";
    readonly loaded: boolean;
    readonly authenticatedUsers: ReadonlyArray<{
      readonly __typename: "User";
      readonly id: c.UserId;
      readonly orgRole: Types.OrgRole;
      readonly email: string;
      readonly org: {
        readonly __typename: "Org";
        readonly id: c.OrgId;
        readonly userCount: number;
        readonly displayName: string;
      };
    }>;
    readonly unauthenticatedUsers: ReadonlyArray<{
      readonly __typename: "User";
      readonly id: c.UserId;
      readonly email: string;
      readonly org: {
        readonly __typename: "Org";
        readonly id: c.OrgId;
        readonly ssoEnforced: boolean;
        readonly displayName: string;
      };
    }>;
  };
};

export const BasicOrgFragmentDoc = /*#__PURE__*/ gql`
  fragment BasicOrgFragment on Org {
    id
    displayName
  }
`;
export const BasicOrgFragmentForPickerFragmentDoc = /*#__PURE__*/ gql`
  fragment BasicOrgFragmentForPicker on User {
    id
    email
    org {
      id
      ...BasicOrgFragment
      ssoEnforced
    }
  }
  ${BasicOrgFragmentDoc}
`;
export const WorkspacePickerFragmentDoc = /*#__PURE__*/ gql`
  fragment WorkspacePickerFragment on User {
    id
    orgRole
    email
    org {
      id
      ...BasicOrgFragment
      userCount
    }
  }
  ${BasicOrgFragmentDoc}
`;
export const OrgsClientDocument = /*#__PURE__*/ gql`
  query OrgsClient {
    orgsClient @client {
      orgs {
        id
        ...BasicOrgFragment
      }
      loaded
    }
  }
  ${BasicOrgFragmentDoc}
`;

/**
 * __useOrgsClientQuery__
 *
 * To run a query within a React component, call `useOrgsClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgsClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgsClientQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrgsClientQuery(
  baseOptions?: Apollo.QueryHookOptions<
    OrgsClientQuery,
    OrgsClientQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<OrgsClientQuery, OrgsClientQueryVariables>(
    OrgsClientDocument,
    options,
  );
}
export function useOrgsClientLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OrgsClientQuery,
    OrgsClientQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<OrgsClientQuery, OrgsClientQueryVariables>(
    OrgsClientDocument,
    options,
  );
}
// @ts-ignore
export function useOrgsClientSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    OrgsClientQuery,
    OrgsClientQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<OrgsClientQuery, OrgsClientQueryVariables>;
export function useOrgsClientSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OrgsClientQuery,
        OrgsClientQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  OrgsClientQuery | undefined,
  OrgsClientQueryVariables
>;
export function useOrgsClientSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OrgsClientQuery,
        OrgsClientQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<OrgsClientQuery, OrgsClientQueryVariables>(
    OrgsClientDocument,
    options,
  );
}
export type OrgsClientQueryHookResult = ReturnType<typeof useOrgsClientQuery>;
export type OrgsClientLazyQueryHookResult = ReturnType<
  typeof useOrgsClientLazyQuery
>;
export type OrgsClientSuspenseQueryHookResult = ReturnType<
  typeof useOrgsClientSuspenseQuery
>;
export type OrgsClientQueryResult = Apollo.QueryResult<
  OrgsClientQuery,
  OrgsClientQueryVariables
>;
export const OrgsPickerClientDocument = /*#__PURE__*/ gql`
  query OrgsPickerClient {
    orgPickerClient @client {
      authenticatedUsers {
        id
        ...WorkspacePickerFragment
      }
      unauthenticatedUsers {
        id
        ...BasicOrgFragmentForPicker
      }
      loaded
    }
  }
  ${WorkspacePickerFragmentDoc}
  ${BasicOrgFragmentForPickerFragmentDoc}
`;

/**
 * __useOrgsPickerClientQuery__
 *
 * To run a query within a React component, call `useOrgsPickerClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgsPickerClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgsPickerClientQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrgsPickerClientQuery(
  baseOptions?: Apollo.QueryHookOptions<
    OrgsPickerClientQuery,
    OrgsPickerClientQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<OrgsPickerClientQuery, OrgsPickerClientQueryVariables>(
    OrgsPickerClientDocument,
    options,
  );
}
export function useOrgsPickerClientLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OrgsPickerClientQuery,
    OrgsPickerClientQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    OrgsPickerClientQuery,
    OrgsPickerClientQueryVariables
  >(OrgsPickerClientDocument, options);
}
// @ts-ignore
export function useOrgsPickerClientSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    OrgsPickerClientQuery,
    OrgsPickerClientQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  OrgsPickerClientQuery,
  OrgsPickerClientQueryVariables
>;
export function useOrgsPickerClientSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OrgsPickerClientQuery,
        OrgsPickerClientQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  OrgsPickerClientQuery | undefined,
  OrgsPickerClientQueryVariables
>;
export function useOrgsPickerClientSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OrgsPickerClientQuery,
        OrgsPickerClientQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    OrgsPickerClientQuery,
    OrgsPickerClientQueryVariables
  >(OrgsPickerClientDocument, options);
}
export type OrgsPickerClientQueryHookResult = ReturnType<
  typeof useOrgsPickerClientQuery
>;
export type OrgsPickerClientLazyQueryHookResult = ReturnType<
  typeof useOrgsPickerClientLazyQuery
>;
export type OrgsPickerClientSuspenseQueryHookResult = ReturnType<
  typeof useOrgsPickerClientSuspenseQuery
>;
export type OrgsPickerClientQueryResult = Apollo.QueryResult<
  OrgsPickerClientQuery,
  OrgsPickerClientQueryVariables
>;
